import type { KyInstance } from 'ky';

import { createApiClient, createAuthedApiClient } from '../client';
import type { ApiClientOptions } from '../types';

const WOLFSWAP_BASE_URL =
    import.meta.env.VITE_WOLFSWAP_API_URL ?? 'https://api.wolfswap.app';

const FACTIONS_BASE_URL =
    import.meta.env.VITE_WOLFSWAP_FACTIONS_API_URL ??
    `${WOLFSWAP_BASE_URL}/factions`;

/** Public MoonHub client. */
export const wolfswapApi = createApiClient(WOLFSWAP_BASE_URL);

/** Cookie-bearing OAuth client. */
export const wolfswapCookieApi = createApiClient(WOLFSWAP_BASE_URL, {
    credentials: 'include',
    headers: { 'X-Snappy-Client': 'web-v1' },
});

/**
 * Application-token MoonHub client. The token proves app identity only;
 * signer-backed mutations additionally carry the HttpOnly trading cookie and
 * are guarded by the callbacks supplied by `useAuthedApi`.
 */
export function createWolfswapAuthedApi(
    getToken: () => string | null,
    onUnauthorized: () => void,
    options: ApiClientOptions = {},
): KyInstance {
    return createAuthedApiClient(WOLFSWAP_BASE_URL, getToken, onUnauthorized, {
        ...options,
        headers: {
            'X-Snappy-Client': 'web-v1',
            ...options.headers,
        },
    });
}

/** Public factions read client. */
export const wolfswapFactionsApi = createApiClient(FACTIONS_BASE_URL);

/**
 * Read-only factions client. It verifies MoonHub's Ed25519 public key, carries
 * no cookies or trading proof, and cannot mint an application token.
 */
export function createWolfswapFactionsAuthedApi(
    getToken: () => string | null,
    onUnauthorized: () => void,
): KyInstance {
    return createAuthedApiClient(FACTIONS_BASE_URL, getToken, onUnauthorized, {
        credentials: 'omit',
    });
}
